/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
* mbp-checkout/CART/LOAD action type is same as the loadcart action on mbp-pwa-ui
* this is done to keep the cart in both places updated
*/

const UPDATE_PERSONALIZATION = 'MFE/MBP-CHECKOUT/UPDATE/PERSONALIZATION/UPDATE_PERSONALIZATION';

export default {
    UPDATE_PERSONALIZATION,
};
